import React, { useEffect } from 'react';
import Login from './Login';
import safeLocalStorage from '../utils/safeStorage';

export default function ProtectedRoute({ authenticated, handleLogin, children }) {
  useEffect(() => {
    if (!authenticated) {
      const currentPath = window.location.pathname + window.location.search;
      if (currentPath && currentPath !== '/') {
        safeLocalStorage.setItem('redirectAfterLogin', currentPath);
      }
    }
  }, [authenticated]);

  if (!authenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return children;
}
